var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy"},[_vm._v("Hello "+_vm._s(_vm.user ? _vm.user.name : '')+", you’ve earned "),_c('strong',[_vm._v(_vm._s(_vm.user ? '$'+_vm.user.cash_earned : '')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }